// eslint-disable-next-line no-shadow
export enum TipoArredondamento {
  CENTESIMAL = 'CENTESIMAL',
  DEZENA = 'DEZENA',
  CENTENA = 'CENTENA',
  MILHAR = 'MILHAR',
}
